import { render, staticRenderFns } from "./ArticleUpdateAdmin.vue?vue&type=template&id=0dfeee07&scoped=true&"
import script from "./ArticleUpdateAdmin.vue?vue&type=script&lang=js&"
export * from "./ArticleUpdateAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ArticleUpdateAdmin.vue?vue&type=style&index=0&id=0dfeee07&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfeee07",
  null
  
)

export default component.exports